import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

import type { CustomContentItem } from "@shared/types/CustomContent";
import type { PaidSponsorTag } from "@shared/types/PaidSponsorTag";

interface SponsoredContentPageEntityParams {
  id: number;
  custom_content_id: number;
  custom_content_type: string;
  slug: string;
  contract_id: string;
  ad_reporting_tags_attributes: PaidSponsorTag[];
  custom_content_items: CustomContentItem[];
}

export class SponsoredContentPageEntity extends BaseEntityClass {
  sponsored_content_page_id: number;
  custom_content_id: number;
  custom_content_type: string;
  slug: string;
  contract_id: string;
  sponsors: PaidSponsorTag[];
  custom_content_items: CustomContentItem[];

  constructor(params: SponsoredContentPageEntityParams) {
    super();
    this.type = "sponsored_content_page";
    this.entity_version = 2;
    this.sponsored_content_page_id = params.id;
    this.custom_content_id = params.custom_content_id;
    this.custom_content_type = params.custom_content_type;
    this.slug = params.slug;
    this.contract_id = params.contract_id;
    this.sponsors = params.ad_reporting_tags_attributes;
    this.custom_content_items = params.custom_content_items;
  }
}
